module.exports = __webpack_public_path__ + "img/测点详情bg@1x.4741f35d.png";